<div class="m-3">
  <table class="table">
    <tr class="row">
      @if (action != 'create') {
        <td class="col-6 text-start">
          API Clients
        </td>
      }
      <td class="col-6 text-end">
        @if (action !== 'create' && filteredClients.length > 0 && errorMessage === '' && !isLoading) {
          <span>
            <button class="btn font-weight-bold btn-link" (click)="exportToExcel()">
              <i class="fa fa-external-link"></i>
              Export to Excel
            </button>
            <button class="btn font-weight-bold btn-link" (click)="exportToCsv()">
              <i class="fa fa-external-link"></i>
              Export to CSV
            </button>
          </span>
        }
        <span>
          @if (action != 'create' && (isAdminClient || isTenantClient)) {
            <button type="button" class="btn btn-link" (click)="updateAction('create')"> Create Client </button>
          }
        </span>
      </td>
    </tr>
  </table>

  <div>
    @if (action == 'create') {
      <div>
        <div appApiClientDetails [client]="newClient" (postActionEvent)="refreshClients($event)" [action]="action">
        </div>
      </div>
    }
  </div>
  <div>
    @if (action == 'update') {
      <div>
        <div appApiClientDetails [client]="newClient" (postActionEvent)="refreshClients($event)" [action]="action">
        </div>
      </div>
    }
  </div>
  <div class="m-3">
    @if (action == 'view') {
      <div class="accordion" id="filterAccordian">
        <div class="accordion-item">
          <h2 class="accordion-header" id="filterHeader">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFilter" aria-expanded="true" aria-controls="collapseFilter">
              Filters
            </button>
          </h2>
          <div id="collapseFilter" class="accordion-collapse collapse" aria-labelledby="filterHeader" data-bs-parent="#filterAccordian">
            <div class="accordion-body">
              <div class="table-responsive-sm">
                <table>
                  <tr class="row">
                    <td class="col-5">Client Id</td>
                    <td class="col-5"><input placeholder="Id" type="text" [(ngModel)]="searchClient.id" id="txtClientId" (keyup.enter)="searchClients()" /></td>
                  </tr>
                  <tr class="row">
                    <td class="col-5 ">Name</td>
                    <td class="col-5"><input placeholder="Name" type="text" [(ngModel)]="searchClient.name" id="txtClientName" (keyup.enter)="searchClients()" /></td>
                  </tr>
                  <tr class="row">
                    <td class="col-10 ">
                      <button type="button" class="m-1" (click)="searchClients()"><i class="bi bi-search" title="Search"></i></button>
                      <button type="button" class="m-1" (click)="refreshClients('reload')"><i class="bi-x-square-fill" title="Reset"></i></button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  @if (action !== 'create' && filteredClients.length == 0 && errorMessage === '' && !isLoading) {
    <div class="container divHover  m-2">
      No Clients available
    </div>
  }
  @if (action !== 'create' && !isLoading) {
    <div class="container divHover  m-2">
      {{errorMessage}}
    </div>
  }
  @if (isLoading) {
    <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
  }
  @if (action == 'view' && filteredClients.length > 0 && !isLoading) {
    <div class="table-responsive-sm m-2">
      <table class="table" #clientDetails>
        <thead>
          <tr>
            <th columnSort class="tableHeader" [data]="filteredClients" data-order="desc" data-name="clientId">
              Id
            </th>
            <th columnSort class="tableHeader" [data]="filteredClients" data-order="desc" data-name="name">
              Name
            </th>
            <th columnSort class="tableHeader" [data]="filteredClients" data-order="desc" data-name="apiKey">
              API Key
            </th>
            <th columnSort class="tableHeader" [data]="filteredClients" data-order="desc" data-name="clientAccessKey">
              AccessKey
            </th>
            <th columnSort class="tableHeader" [data]="filteredClients" data-order="desc" data-name="isActive">
              Active
            </th>
            <th columnSort class="tableHeader" [data]="filteredClients" data-order="desc" data-name="clientType">
              Client Type
            </th>
            <th columnSort class="tableHeader" [data]="filteredClients" data-order="desc" data-name="ApiAccessIds">
              Associations
            </th>
            <th columnSort class="tableHeader" [data]="filteredClients" data-order="desc" data-name="updateAt">
              Updated On
            </th>
            @if (isAdminClient) {
              <th>Edit</th>
            }
            @if (action == 'view' && isAdminClient) {
              <th>Delete</th>
            }
          </tr>
        </thead>
        @for (client of (filteredClients | paginate: { itemsPerPage:15, currentPage: p} ); track client) {
          <tbody>
            <tr appApiClientDetails [client]="client"
              (postActionEvent)="refreshClients($event)" [action]="action">
            </tr>
          </tbody>
        }
      </table>
      <table class="table">
        <tr>
          <td>
            <pagination-controls (pageChange)="p = $event" [directionLinks]="true"
              [autoHide]="true"
              [responsive]="true"
              previousLabel="Previous"
              nextLabel="Next"
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"
            screenReaderCurrentLabel="You're on page"></pagination-controls>
          </td>
        </tr>
      </table>
    </div>
  }
</div>
